import { render, staticRenderFns } from "./assessDialog1.vue?vue&type=template&id=5d961e97&scoped=true"
import script from "./assessDialog1.vue?vue&type=script&lang=js"
export * from "./assessDialog1.vue?vue&type=script&lang=js"
import style0 from "./assessDialog1.vue?vue&type=style&index=0&id=5d961e97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d961e97",
  null
  
)

export default component.exports